import React from "react";
import { profile, navLinks } from "../mock/mock";
import { Linkedin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-ivory-50 border-t border-ink/10 py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-sm bg-ink text-ivory-50 grid place-items-center font-serif-display text-sm tracking-wider">
                {profile.initials}
              </div>
              <div>
                <div className="font-serif-display text-lg text-ink">{profile.name}</div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-ink/55">
                  {profile.title}
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-ink/65 leading-relaxed max-w-sm">
              15+ years leading managed services, IT operations and commercial growth across the UAE, KSA and Oman.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-ink/55 mb-4">
              Navigate
            </div>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-ink/75 hover:text-bronze transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-ink/55 mb-4">
              Elsewhere
            </div>
            <div className="flex flex-col gap-3">
              <a
                href={profile.linkedin}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 text-sm text-ink/80 hover:text-bronze transition-colors"
              >
                <Linkedin className="h-4 w-4" /> LinkedIn
              </a>
              <a
                href={`mailto:${profile.email}`}
                className="inline-flex items-center gap-3 text-sm text-ink/80 hover:text-bronze transition-colors"
              >
                <Mail className="h-4 w-4" /> {profile.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-ink/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-ink/55">
          <div>© {new Date().getFullYear()} {profile.name}. All rights reserved.</div>
          <div className="uppercase tracking-[0.22em]">Abu Dhabi · UAE</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
